import { cn } from '@/lib/design-system';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  align?: 'left' | 'center';
}

const sizeStyles = {
  sm: {
    container: 'py-8',
    icon: '[&>svg]:h-8 [&>svg]:w-8',
    title: 'text-sm',
    description: 'text-xs',
  },
  md: {
    container: 'py-12',
    icon: '[&>svg]:h-10 [&>svg]:w-10',
    title: 'text-base',
    description: 'text-sm',
  },
  lg: {
    container: 'py-16',
    icon: '[&>svg]:h-12 [&>svg]:w-12',
    title: 'text-lg',
    description: 'text-base',
  },
};

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
  size = 'md',
  align = 'center',
}: EmptyStateProps) {
  const styles = sizeStyles[size];

  return (
    <div
      className={cn(
        'flex flex-col',
        align === 'left' ? 'items-start text-left' : 'items-center justify-center text-center',
        styles.container,
        className
      )}
    >
      {icon && (
        <div
          className={cn('mb-4 text-default-400', styles.icon)}
          aria-hidden="true"
        >
          {icon}
        </div>
      )}

      <h3 className={cn('font-medium text-foreground', styles.title)}>
        {title}
      </h3>

      {description && (
        <p
          className={cn(
            'mt-1 max-w-sm text-default-500',
            styles.description
          )}
        >
          {description}
        </p>
      )}

      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
